export default __webpack_public_path__ + "static/jakeB-a3f0d1fef03519cb0754ed084ec104b7.jpg";